import { atom } from 'jotai'
import { Subscription } from 'types/subscription'

export const subscriptionAtom = atom<Subscription | null>(null)
export const subscriptionLoadingAtom = atom<boolean>(false)
export const reactivateIsInProgressAtom = atom<boolean>(false)
